import { Observable } from "rxjs";
import { ICardinal } from "./ICardinal";
import { ICardinalLoadStrategy } from "./ICardinalLoadStrategy";
import { CardinalScriptLoader } from "./CardinalScriptLoader";

export interface ICardinalV1Config {
  url: string;
}

export class CardinalV1Loader implements ICardinalLoadStrategy {
  constructor(
    private scriptLoader: CardinalScriptLoader,
    private config: ICardinalV1Config,
  ) {}

  load(): Observable<ICardinal> {
    return this.scriptLoader.loadScript(this.config.url);
  }
}
